import { combineReducers } from "redux";
import basicRequest from "../../../core/redux/reducers/request";

const l3 = basicRequest("CACHE_L3");
const l4 = basicRequest("CACHE_L4");

const specialization = basicRequest("CACHE_SPECIALIZATION");
const service = basicRequest("CACHE_SERVICE");
const unit = basicRequest("CACHE_UNIT");
const language = basicRequest("CACHE_LANGUAGE");
const languagePair = basicRequest("CACHE_LANGUAGE_PAIR");
const country = basicRequest("CACHE_COUNTRY");
const currency = basicRequest("CACHE_CURRENCY");
const campaign = basicRequest("CACHE_CAMPAIGN");
const catlog = basicRequest("CACHE_CATLOG");
const tag = basicRequest("CACHE_TAG");
const priority = basicRequest("CACHE_PRIORITY");

const client = basicRequest("CACHE_CLIENT");
const vendor = basicRequest("CACHE_VENDOR");
const manager = basicRequest("CACHE_MANAGER");

export default combineReducers({
    specialization,
    service,
    unit,
    language,
    languagePair,
    currency,
    country,
    campaign,
    catlog,
    client,
    vendor,
    manager,
    tag,
    priority,

    l3,
    l4,
});
